export default __webpack_public_path__ + "static/media/Wealth.20b986b2.webp";